"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetProductListingData = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _editorialFetching = require("@ori/editorial-fetching");
var _presentationHttp = require("@ori/presentation-http");
var _react = require("react");
var _constants = require("../constants");
var _loadProductListingData = require("./loadProductListingData");
/* istanbul ignore file */ const useGetProductListingData = (param)=>{
    let { pageId } = param;
    const { graphQlNetUrl } = (0, _configurationManager.useServiceUrls)([
        'graphQlNet'
    ]);
    const { headers } = (0, _presentationHttp.useHeaders)();
    const previewMode = (0, _react.useMemo)(()=>(0, _editorialFetching.getPreviewMode)(), []);
    const getProductListingData = (0, _react.useCallback)(async (param)=>{
        let { skip, limit = _constants.PAGINATION_LIMIT_ROWS, orderBy, facetFiltering } = param;
        var _response_application_editorialPage, _response_application;
        const response = await (0, _loadProductListingData.loadProductListingData)({
            limit,
            skip,
            pageId,
            orderBy,
            graphQlUrl: graphQlNetUrl,
            headers,
            facetFiltering,
            previewMode
        });
        return (_response_application = response.application) === null || _response_application === void 0 ? void 0 : (_response_application_editorialPage = _response_application.editorialPage) === null || _response_application_editorialPage === void 0 ? void 0 : _response_application_editorialPage.contentItems;
    }, [
        graphQlNetUrl,
        headers,
        pageId,
        previewMode
    ]);
    return {
        getProductListingData
    };
};
exports.useGetProductListingData = useGetProductListingData;
